import { createSlice } from "@reduxjs/toolkit";
import { fetchBrighterScoreApi, fetchBrighterScoreCarrierApi } from "./BrighterScoreActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";


const brighterScoreCarrierApi = createSlice({
    name: "brighterScoreCarrierApi",
    initialState: {
        isBrighterScoreCarrierDataLoading: false,
        brighterScoreCarrierData: {},
        brighterScoreCarrierError: null,
        brighterScoreCarrierErrorMsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBrighterScoreCarrierApi.pending, (state) => {
                state.isBrighterScoreCarrierDataLoading = true;
                state.brighterScoreCarrierError = null;
            })
            .addCase(fetchBrighterScoreCarrierApi.fulfilled, (state, action) => {
                state.isBrighterScoreCarrierDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata?.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.brighterScoreCarrierError = false;
                        state.brighterScoreCarrierData = {};
                    }
                    else {
                        state.brighterScoreCarrierError = true;
                        state.brighterScoreCarrierErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.brighterScoreCarrierError = false;
                    state.brighterScoreCarrierData = action.payload.data.data.accessPointBrighterScoreCarrierResponseDTO;
                }
            })
            .addCase(fetchBrighterScoreCarrierApi.rejected, (state, action) => {
                state.isBrighterScoreCarrierDataLoading = false;
                state.brighterScoreCarrierError = action.error.message;
            });
    },
});

const brighterScore = createSlice({
    name: "brighterScore",
    initialState: {
        isBrighterScoreDataLoading: false,
        brighterScoreData: [],
        brighterScoreError: null,
        brighterScoreErrorMsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBrighterScoreApi.pending, (state) => {
                state.isBrighterScoreDataLoading = true;
                state.brighterScoreError = null;
            })
            .addCase(fetchBrighterScoreApi.fulfilled, (state, action) => {
                state.isBrighterScoreDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata?.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.brighterScoreError = false;
                        state.brighterScoreData = [];
                    }
                    else {
                        state.brighterScoreError = true;
                        state.brighterScoreErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.brighterScoreError = false;
                    state.brighterScoreData = action.payload.data.data.accessPointBrighterScoreResponseDTO;
                }
            })
            .addCase(fetchBrighterScoreApi.rejected, (state, action) => {
                state.isBrighterScoreDataLoading = false;
                state.brighterScoreError = action.error.message;
            });
    },
});


export const brighterScoreReducer = brighterScore.reducer;
export const brighterScoreCarrierApiReducer = brighterScoreCarrierApi.reducer;